import { observable }         from 'rewire-core';
import { IToggleMenuItem }    from 'rewire-ui';
import { reportRouteManager } from '../main-navigation/RouteManager';

export interface IReportOptions {
  showParameters?: boolean;
  showGeneralComments?: boolean;
}

export interface IReportOptionsModelState {
  options: IReportOptions;
  items:   IToggleMenuItem[];
}

export default class ReportOptionsModel<TState = unknown> {
  state: IReportOptionsModelState & TState;

  constructor() {
    this.state = observable({
      options: undefined,
      items:   [
        {name: 'showParameters',      title: 'Parameters',       active: () => this.options?.['showParameters'],      onClick: this.toggleParameters},
        {name: 'showGeneralComments', title: 'General Comments', active: () => this.options?.['showGeneralComments'], onClick: this.toggleGeneralComments, visible: () => !!reportRouteManager.viewId},
      ],
    }) as any;
  }

  load() {
    this.state.options = reportRouteManager.options ? {...reportRouteManager.options} : this.getDefaultOptions();
  }

  get options(): any {
    return this.state.options;
  }

  get items(): IToggleMenuItem[] {
    return this.state.items;
  }

  getDefaultOptions() {
    return ({
      showParameters: false,
      showGeneralComments: true,
    });
  }

  toggleParameters = () => {
    this.state.options.showParameters = !this.options.showParameters;
    this.apply();
  };

  toggleGeneralComments = () => {
    this.state.options.showGeneralComments = !this.options.showGeneralComments;
    this.apply();
  };

  apply() {
    setTimeout(() => {
      reportRouteManager.navigateTo({options: this.options});
    }, 0);
  }
}
